import { APP_ROUTES } from '@efficiently/client-core-routing';
import { buildRoomsRoutes } from '@efficiently/client-domain-rooms';

/** The portal pages as the platform shell's Client Portal section mounts them, under `client-portal`. */
export const CLIENT_PORTAL_ROUTES_CONST = buildRoomsRoutes(APP_ROUTES.CLIENT_PORTAL.path);
